import { industryChainRoute } from '@/views/industryChainNew/router'
import { queryIndustryChain } from '@/api/asyncRouterApi'
import { getSelectArea, getIndustryInfo, getGeoJson } from '@/api/asyncRouterApi'
import { flattenTree } from '@/utils/util'
const asyncRoute = {
  state: {
    isGetRoute: false,
    routeList: [],
    industryChain: [],
    theClassify: [],
    allChainList: [],
    chainIDMap: {},
    selectArea: [],
    selectAreaFlatten: [],
    selectAreaFlattenMap: {},
    // selectArea1: [],
    // selectArea2: [],
    // selectArea3: [],

    industryInfo: [],
    industryInfoFlatten: [],
    industryInfoFlattenMap: {},
  },
  mutations: {
    SET_ROUTE(state, router) {
      state.routeList = router
      state.isGetRoute = true
    },
    SET_DATA(state, industryChain) {
      state.industryChain = industryChain

      state.theClassify = Object.keys(industryChain) || []
      let list = []
      for (let index = 0; index < state.theClassify.length; index++) {
        const element = industryChain[state.theClassify[index]]
        list = [...list, ...element]
      }

      // state.allChainList = list
      // state.chainIDMap = list.reduce((p, v) => (p[v.secId] = v, p), {})


      // 需要去重 后端不好处理(只使用 secId 作为重复标识)
      const chainCaches = {}
      const allChainList = []
      list.forEach(e => {
        if (!chainCaches[e.secId]) {
          chainCaches[e.secId] = true
          allChainList.push(e)
        }
      })
      state.allChainList = allChainList
      state.chainIDMap = allChainList.reduce((p, v) => (p[v.secId] = v, p), {})
    },

    SET_AREA(state, area) {
      state.selectArea = area
      const result = flattenTree(area, 'childOption')
      state.selectAreaFlatten = result
      state.selectAreaFlattenMap = result.reduce((p, v) => (p[v.value] = v, p), {})

      // result.forEach((e, i) => {
      //   state['selectArea' + e.level].push(e)
      // })
    },
    SET_INDUSTRY(state, industryInfo) {
      state.industryInfo = industryInfo
      const result = flattenTree(industryInfo)

      state.industryInfoFlatten = result
      state.industryInfoFlattenMap = result.reduce((p, v) => (p[v.industryCode] = v, p), {})
      // selectAreaFlattenMap
    }
  },

  actions: {
    async getRouters({ commit }) {
      try {
        const { code, data } = await queryIndustryChain()
        if (code === 200 && data) {
          // for (const key in data) {
          //   if (Object.hasOwnProperty.call(data, key)) {
          //     const element = data[key]
          //     industryChainRoute[0].children.push({
          //       path: element[0]?.firstId,
          //       component: () => import('@/views/industryChainNew/page/index'),
          //       name: key,
          //       hidden: false,
          //       hide: false,
          //       meta: {
          //         title: key,
          //         // icon: 'leftIcon3',
          //         breadcrumb: ['产业获客', key]
          //       }
          //     })
          //   }
          // }
          // commit('SET_ROUTE', industryChainRoute)
          commit('SET_DATA', data)

          // return industryChainRoute
        }
        return []
      }
      catch (error) {
        return []
      }
    },
    async getSelectArea({ commit, state }) {
      if (state.selectArea.length) return
      try {
        const { code, data } = await getSelectArea()
        if (code === 200) {
          commit('SET_AREA', data?.optionVos || [])
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getIndustryInfo({ commit, state }) {
      if (state.industryInfo.length) return
      try {
        const { code, data } = await getIndustryInfo()
        if (code === 200) {
          commit('SET_INDUSTRY', data || [])
        }
      } catch (error) {
        console.log(error)
      }
    },

  }
}

export default asyncRoute